/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetConfig200ResponseReservationDurationsValuesInner } from './GetConfig200ResponseReservationDurationsValuesInner';
import {
    GetConfig200ResponseReservationDurationsValuesInnerFromJSON,
    GetConfig200ResponseReservationDurationsValuesInnerFromJSONTyped,
    GetConfig200ResponseReservationDurationsValuesInnerToJSON,
    GetConfig200ResponseReservationDurationsValuesInnerToJSONTyped,
} from './GetConfig200ResponseReservationDurationsValuesInner';

/**
 * 
 * @export
 * @interface GetConfig200ResponseReservationDurations
 */
export interface GetConfig200ResponseReservationDurations {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseReservationDurations
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseReservationDurations
     */
    value?: number;
    /**
     * 
     * @type {Array<GetConfig200ResponseReservationDurationsValuesInner>}
     * @memberof GetConfig200ResponseReservationDurations
     */
    values?: Array<GetConfig200ResponseReservationDurationsValuesInner>;
}

/**
 * Check if a given object implements the GetConfig200ResponseReservationDurations interface.
 */
export function instanceOfGetConfig200ResponseReservationDurations(value: object): value is GetConfig200ResponseReservationDurations {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseReservationDurationsFromJSON(json: any): GetConfig200ResponseReservationDurations {
    return GetConfig200ResponseReservationDurationsFromJSONTyped(json, false);
}

export function GetConfig200ResponseReservationDurationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseReservationDurations {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'] == null ? undefined : json['value'],
        'values': json['values'] == null ? undefined : ((json['values'] as Array<any>).map(GetConfig200ResponseReservationDurationsValuesInnerFromJSON)),
    };
}

export function GetConfig200ResponseReservationDurationsToJSON(json: any): GetConfig200ResponseReservationDurations {
    return GetConfig200ResponseReservationDurationsToJSONTyped(json, false);
}

export function GetConfig200ResponseReservationDurationsToJSONTyped(value?: GetConfig200ResponseReservationDurations | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
        'values': value['values'] == null ? undefined : ((value['values'] as Array<any>).map(GetConfig200ResponseReservationDurationsValuesInnerToJSON)),
    };
}

